import { render } from "./VirtualTourPoint.vue?vue&type=template&id=7345bd9a"
import script from "./VirtualTourPoint.vue?vue&type=script&lang=js"
export * from "./VirtualTourPoint.vue?vue&type=script&lang=js"

import "./VirtualTourPoint.vue?vue&type=style&index=0&id=7345bd9a&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__